export default "/images/eac904e8b2820f86038f5b49bc582d8d.avif";